import { Trans, useTranslation } from 'react-i18next';
import { cn } from '@shared/lib/utils';

interface ConfirmationsCounterProps {
  current: number;
  required: number;
  className?: string;
}

export function ConfirmationsCounter({ current, required, className }: ConfirmationsCounterProps) {
  const { t } = useTranslation('invoice-pay');
  // API после paid отдаёт current > required (14/12) — показываем не больше порога
  const shown = Math.min(Math.max(current, 0), required);

  return (
    <p
      className={cn('text-sm font-normal leading-none text-base-muted-foreground', className)}
      aria-live="off"
    >
      <Trans
        t={t}
        i18nKey="confirmationFrom"
        values={{ current: shown, required }}
        components={{ required: <span className="font-normal text-success-foreground" /> }}
      />
    </p>
  );
}
